module.exports = __webpack_public_path__ + "static/media/argent.54b72b5e.jpg";